import { render, staticRenderFns } from "./companyappinvoice.vue?vue&type=template&id=3dd16adb&"
import script from "./companyappinvoice.vue?vue&type=script&lang=js&"
export * from "./companyappinvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports